import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import { useState } from "react"

export function useDeleteList() {
  const [isDeleteListLoading, setIsDeleteListLoading] = useState<boolean>(false)
  const request = useAxiosRequest()
  const deleteList = async (listID: string) => {
    setIsDeleteListLoading(true)
    await request<any, any>({
      url: `${BASE_URL}/vesseltracking/list/single`,
      method: "DELETE",
      params: {listID},
    })

    setIsDeleteListLoading(false)
  }
  return { deleteList, isDeleteListLoading }
}
